<div class="mat-dialog-custom eula-container">
  <div class="title-container display-flex-container">
    <h1 class="title" i18n>End User License Agreement</h1>
  </div>
  <div class="inner">
    <div class="text-container">
      <p i18n>Our terms and conditions have changed, you must accept to continue.</p>
      <a id="eulaUrl" target="_blank" [href]="eulaUrl" i18n>End User License Agreement</a>
    </div>
    <div class="buttons-container">
      <button id="declineEULA" class="button secondary-button" type="button" (click)="logout()" i18n>
        Decline and Log Out
      </button>
      <button id="acceptEULA" class="button primary-button" type="submit" i18n>Accept</button>
    </div>
  </div>
</div>
